import React from "react";

import { Link } from "react-router-dom";


function NavbarLeftItem({ icon, text, href, disabled = false }) {
  return (
    <div className="w-full">
      <a href={disabled ? '#':href} className={disabled ? "cursor-default":""}>
        <div className={"grid grid-cols-12 " + (disabled ? "text-gray-500":"text-white hover:text-ame-orange") + " text-center py-6"}>
          <div className="col-span-12">
            {icon}
          </div>
          <div className="col-span-12">
            {text}
          </div>
        </div>
      </a>
    </div>
  );
}

export default NavbarLeftItem;